import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import TooltipOption from "../../../../core/common/tooltipOption";
import { _get, _post } from "../../../Utils/Helper";
import { all_routes } from "../../../router/all_routes";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { SingleValue } from "react-select";
import {
  acadamicTerms,
  sections,
} from "../../../../core/common/selectoption/selectoption";
import { RootState } from "../../../../redux/reducers";
import { useSelector } from "react-redux";
import { toExcel } from "../../../../core/common/helpers";
import { Input } from "antd";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { classNames } from "primereact/utils";

// Define types for student and form data
interface Student {
  admission_no: string;
  student_name: string;
  current_class: string;
  subject: string;
  aggregate_score?: number;
  total_score: number;
  aggregate_grade: string;
  position: number;

}
interface SubjectScore {
  subject: string;
  caScore: string;
  assignmentScore: string;
  examScore: string;
}
interface FormData {
  admission_no: string;
  student_name: string;
  caScore: string;
  assignmentScore: string;
  examScore: string;
  subject: SubjectScore[];
  class_name: string;
  status: string;
  aggregate_score: number;
  total_score: number;
  aggregate_grade: string;
  position: number;

  // admission_no: string;
}

interface Calendar {
  admission_no: string;
  id: string;
  exam_name: string;
  academic_year: string;
  exam_type: string;
  term: string;
  start_date: string;
  end_date: string;
  status: string;
}
const GenereteClassReports = () => {
  const routes = all_routes;

  const [calendar, setCalendar] = useState<Calendar[]>([]);
  // const [new_data, setNewData] = useState<Classes[]>([]);
  const { classes } = useSelector((state: RootState) => state.auth);
  const { academic_calendar } = useSelector((state: any) => state.auth);
  const classOptions =
    classes?.length > 0
      ? classes.map((item:any) => ({
          label: item.class_name,
          value: item.section,
          section: item.section,
        }))
      : [];
  const [sectionSubjects, setSectionSubjects] = useState<any[]>([]);

  // const subjectOptions =
  //   subjects?.length > 0
  //     ? subjects?.map((item) => ({ label: item.subject, value: item.subject }))
  //     : [];
  const calendarOptions =
    calendar?.length > 0
      ? calendar?.map((item) => ({ label: item.exam_name, value: item.id }))
      : [];

  // const [students, setStudents] = useState<Student[]>([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [formData, setFormData] = useState<FormData[]>([]);
  const { user } = useSelector((state: RootState) => state.auth);
  const [grade_setup, setGradeSetup] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({
    studentId: "",
    studentName: "",
  });
  

  const [subjects, setSubjects] = useState<Student[]>([]);

  const [form, setForm] = useState({
    term: "",
    subject: "",
    class_name: "",
    academic_year: academic_calendar?.length ? academic_calendar[0]?.academic_year:"",
    mark_by: user.name,
    calendar_id: "",
    calendar_name: "",
    section: "",
  });
  useEffect(() => {
    if (form.class_name) {
      const section = classes.length
        ? classes.find((x) => x.class_name === form.class_name)?.section
        : "";
      // console.error({ section });

      setSectionSubjects(subjects.filter((x: any) => x.section === section));
    }
  }, [form.class_name, subjects.length]);
  const getCalendar = useCallback(() => {
    _get(
      "exam_calendar?query_type=select-all",
      (res) => {
        if (res.success && res.data && res.data.length) {
          setCalendar(res.data);
        }
      },
      (err) => {
        console.error("Error fetching calendar:", err);
      }
    );
  }, []);

  useEffect(() => {
    if (form.section) {
      _get(
        `get_subjects?query_type=select-section-subjects&section=${form.section}`,
        (res) => {
          if (res.success && res.data && res.data.length) {
            setSubjects(res.data);
          }
        },
        (err) => {
          console.error("Error fetching calendar:", err);
        }
      );
    }
  }, [form.section]);

  const getGrade = useCallback(() => {
    _get(
      "grade-setup?query_type=select-all",
      (res) => {
        if (res.success && res.data && res.data.length) {
          setGradeSetup(res.data);
        }
      },
      (err) => {
        console.error("Error fetching calendar:", err);
      }
    );
    
  }, []);
  const handleClose = () => {
    setShow(false);
  };
  
  useEffect(() => {
    if (!form.class_name || subjects.length === 0) {
      setFormData([]); // Reset if no class_name or subjects are empty
      return;
    }
  
    _get(
      `get_class_results?query_type=Select Class Reports&class_name=${form.class_name}`,
      (res) => {
        if (res.success && res.data) {
          const initializedFormData = res.data.map((student: Student) => ({
            admission_no: student.admission_no,
            student_name: student.student_name,
            class_name: form.class_name,
            total_score: student.total_score,
            position: student.position
          }));
            // setForm((p) => ({ ...p, academic_year: academic_calendar?.length && academic_calendar[0]?.academic_year }));
          console.log("init", initializedFormData);
          console.log("subject", subjects);
  
          setFormData(initializedFormData);
        } else {
          console.error("No data found in response:", res);
          setFormData([]);
        }
      },
      (err) => {
        console.error("Error fetching students:", err);
        setFormData([]);
      }
    );
  }, [form.class_name, subjects]); // Add subjects to dependencies
  
  const handleClassChange = (value: any, section: any) => {
    setForm((p) => ({ ...p, class_name: value, section: section }));
    // getSubjectsByClass(value);
    setForm((p) => ({ ...p, class_name: value }));
    // Update class_name in formData when the class changes
    const updatedFormData = formData.map((student) => ({
      ...student,
      class_name: value,
      mark_by: user.name,
      admission_no: student.admission_no,
    }));
    setFormData(updatedFormData);
  };

  const handleInputChange = (
    field: keyof SubjectScore,
    value: string,
    studentIdx: number,
    subjectIdx: number
  ) => {
    setFormData((prevData) => {
      const updatedFormData = [...prevData];

      if (!updatedFormData[studentIdx]?.subject[subjectIdx]) {
        console.error(
          "Invalid student or subject index:",
          studentIdx,
          subjectIdx
        );
        return prevData; // Return previous state to prevent undefined access
      }

      updatedFormData[studentIdx] = {
        ...updatedFormData[studentIdx],
        subject: updatedFormData[studentIdx].subject.map((sub, idx) =>
          idx === subjectIdx
            ? { ...sub, [field]: value ? Number(value) : 0 }
            : sub
        ),
      };

      return updatedFormData;
    });
  };

  const handleSubmit = () => {
    if (!form.term) {
      toast.warning("Please select a valid term");
      return;
    }
    if (!form.class_name) {
      toast.warning("Please select a valid class");
      return;
    }
    if (!formData.length) {
      toast.warning(
        "No students found in the selected class\r\nPlease select class or Upload an Excell file"
      );
      return;
    }

    const payload = formData.flatMap((student) =>
      student.subject
        .filter(
          (subject) =>
            subject.caScore !== "" &&
            subject.assignmentScore !== "" &&
            subject.examScore !== ""
        )
        .map((subject) => ({
          calendar_id: form.calendar_id,
          admission_no: student.admission_no,
          student_name: student.student_name,
          caScore: subject.caScore,
          assignmentScore: subject.assignmentScore,
          examScore: subject.examScore,
          subject: subject.subject,
          class_name: student.class_name,
          term:  academic_calendar && academic_calendar[0].term,
          academic_year: academic_calendar && academic_calendar[0].academic_year,
          mark_by: user.name,
          query_type: "create",
          school_id: user.school_id,
        }))
    );

    console.log("Filtered Payload:", formData);

    _post(
      "exams/gradings",
      payload,
      (res) => {
        if (res.success) {
          console.log("Submission successful", res);
          setSelectedStudent({ studentId: "", studentName: "" });
          setShow(false);
          toast.success("Submitted successfully!");
        }
      },
      (err) => {
        console.log("Error submitting data", err);
        toast.error("There was an error submitting the data.");
      }
    );
  };

  useEffect(() => {
    getCalendar();
    getGrade();
  }, [getCalendar]);

  const handleEditClick = (studentId: string, studentName: string) => {
    setSelectedStudent({ studentId, studentName });

    console.log({ studentId, studentName });
  };

  const columns = [
    {
      title: "Admission No",
      dataIndex: "admission_no",
      render: (text: string, record: Student) => (
        <Link
          to="#"
          onClick={() => {
            setShow(true);
            handleEditClick(record?.admission_no, record.student_name);
          }}
          className="link-primary"
        >
          {record.admission_no}
        </Link>
      ),
    },
    {
      title: "Student Name",
      dataIndex: "student_name",
      render: (text: string) => (
        <span className="attendance-range">{text}</span>
      ),
    },
    {
      title: "Aggregate Score",
      dataIndex: "aggregate_score",

      render: (text: string, record: any) => (
        <span className="attendance-range">{(record?.total_score>0)? text:'-'}</span>
      ),
    },
    {
      title: "Grade Score",
      dataIndex: "total_score",
      render: (text: string, record: Student) => (
        <span className="attendance-range">{(record?.total_score>0)? text:'-'}</span>
      ),
    },
    {
      title: "Remark",
      dataIndex: "aggregate_grade",
      render: (text: string, record: Student) => {
        const studentData = formData.find(
          (item) => item.admission_no === record.admission_no
        );
        const total =
          Number(text||0);

        return total > 0 ? (
          <span style={{ fontWeight: "bold", color: "blue" }}>
            {getRemark(total, grade_setup)}
          </span>
        ) : (
          <span>{(record?.total_score>0)? text:'-'}</span>
        );
      },
    },
    {
      title: "Possion",
      dataIndex: "position",
      render: (text: number, record: Student) => (
        <span className="attendance-range">{(record?.total_score>0)? text:'-'}</span>
      ),
    },
  ];

  const inputStyle = {
    border: "1px solid #000",
    padding: "5px",
    borderRadius: "5px",
    width: "100px",
  };

  const getRemark = (
    score: number,
    setup: { min_score: number; max_score: number; remark: string }[]
  ) => {
    if (!setup.length) return "No Remark";

    const found = setup.find(
      ({ min_score, max_score }) => score >= min_score && score <= max_score
    );

    return found ? found.remark : "No Remark";
  };

  const getGrades = (
    score: number,
    setup: { min_score: number; max_score: number; grade: string }[]
  ) => {
    if (!setup.length) return "N/A";

    const found = setup.find(
      ({ min_score, max_score }) => score >= min_score && score <= max_score
    );

    return found ? found.grade : "N/A";
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-4 mt-4s">
            {/* {JSON.stringify(formData)} */}

            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Exam Entries </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Academic </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Exam Entries
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <div className="col-md-6 col-sm-3 m b-2">
                <Input
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileUpload}
                  name="template"
                  placeholder="Upload excell"
                />
              </div>
              <TooltipOption with_export setExport={processExport} /> */}
            </div>
          </div>
          <div className="card p-3">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                gap: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <label>Academic Year</label>
                <input
                  type="text"
                  className="form-control"
                  value={academic_calendar && academic_calendar[0].academic_year}
                  disabled
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <label>Term</label>
                <CommonSelect
                  options={ academic_calendar && academic_calendar[0].term ? [{ label: academic_calendar && academic_calendar[0].term, value: academic_calendar && academic_calendar[0].term }] : []}
                  defaultValue={{
                    label: academic_calendar && academic_calendar[0].term,
                    value: academic_calendar && academic_calendar[0].term,
                  }}
                  handleChange={(newValue: SingleValue<Option>) =>
                    setForm((prev) => ({
                      ...prev,
                      term: newValue ? newValue.value : "",
                    }))
                  }
                />
                {/* <input
              type="text"
              className="form-control"
              value={form.term}
              disabled
              /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <label>Select Class</label>
                <CommonSelect
                  options={classOptions}
                  defaultValue={{
                    label: form.class_name,
                    value: form.class_name,
                  }}
                  handleChange={(newValue: SingleValue<Option>) =>
                    handleClassChange(newValue?.label, newValue?.value)
                  }
                />
              </div>
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <label>Select Subject</label>
                <CommonSelect
                  options={subjectOptions}
                  defaultValue={{
                    label: form.subject,
                    value: form.subject,
                  }}
                  handleChange={(newValue: SingleValue<Option>) =>
                    handleSubjectChange(newValue?.value)
                  }
                />
              </div> */}
            </div>
          </div>

          <div>
            {/* {JSON.stringify(sectionSubjects.sort(function(a, b){return a.subject_code - b.subject_code}))}
            {JSON.stringify(subject)} */}
            {/* {JSON.stringify( academic_calendar)} */}
            <Table columns={columns} dataSource={formData} />
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered size="xl">
        <div
          className="modal-header bg-white"
          style={{ position: "sticky", top: "0", zIndex: "1000" }}
        >
          <h4 className="modal-title">
            {selectedStudent.studentName} - {selectedStudent.studentId}
          </h4>
          <button
            type="button"
            className="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body mb-0 table-responsive-md">
          <div
            className="table-responsive table-striped"
            style={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            <table className="table table-sm table-bordered">
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 2,
                }}
              >
                <tr>
                  <th>SUBJECT</th>
                  <th>
                    1<sup>ST</sup> C/A
                  </th>
                  <th>
                    2 <sup>ND</sup> C/A
                  </th>
                  <th>EXAM</th>
                  <th>TOTAL SCORE</th>
                  <th>GRADE</th>
                  <th>REMARK</th>
                </tr>
              </thead>
              <tbody>
                {sectionSubjects?.map((subject, subjectIdx) => {
                  if (!selectedStudent || !selectedStudent.studentId) {
                    console.error(
                      "selectedStudent or selectedStudent.studentId is undefined."
                    );
                    return;
                  }

                  const studentData = formData.find(
                    (item) => item.admission_no === selectedStudent.studentId
                  );

                  if (!studentData) {
                    console.error(
                      "No student data found for the given studentId."
                    );
                    return;
                  }

                  if (
                    Array.isArray(studentData.subject) &&
                    studentData.subject.length > subjectIdx
                  ) {
                    const subjectData = studentData.subject[subjectIdx];

                    const caScore = Number(subjectData?.caScore ?? 0);
                    const assignmentScore = Number(
                      subjectData?.assignmentScore ?? 0
                    );
                    const examScore = Number(subjectData?.examScore ?? 0);

                    // const totalScore = caScore + assignmentScore + examScore;
                  } else {
                    console.error(
                      "Invalid subjectIdx or no subjects found for this student."
                    );
                  }

                  // const studentData = formData.find(
                  //   (item) => item.admission_no === selectedStudent?.studentId
                  // );
                  const subjectData = studentData?.subject[subjectIdx];
                  let totalScore: string | number = "-";

                  if (
                    subjectData?.caScore &&
                    subjectData?.assignmentScore &&
                    subjectData?.examScore
                  ) {
                    totalScore =
                      Number(subjectData?.caScore) +
                      Number(subjectData?.assignmentScore) +
                      Number(subjectData?.examScore);
                  }
                  return (
                    <tr key={subjectIdx}>
                      <td>{subject.subject}</td>
                      <td>
                        <input
                          style={inputStyle}
                          min={0}
                          max={10}
                          type="number"
                          placeholder="First C/A marks"
                          value={subjectData?.caScore ?? ""}
                          onChange={(e) => {
                            const inputValue = (e.target as HTMLInputElement)
                              .value;
                            const value = Math.min(
                              10,
                              Math.max(0, Number(inputValue) || 0)
                            ).toString(); // Convert to string
                            handleInputChange(
                              "caScore",
                              value,
                              formData.findIndex(
                                (item) =>
                                  item.admission_no ===
                                  selectedStudent.studentId
                              ),
                              subjectIdx
                            );
                          }}
                        />
                      </td>
                      <td>
                        <input
                          style={inputStyle}
                          min={0}
                          max={20}
                          type="number"
                          placeholder="Second C/A marks"
                          value={subjectData?.assignmentScore ?? ""}
                          onChange={(e) => {
                            const inputValue = (e.target as HTMLInputElement)
                              .value;
                            const value = Math.min(
                              20,
                              Math.max(0, Number(inputValue) || 0)
                            ).toString(); // Convert to string
                            handleInputChange(
                              "assignmentScore",
                              value,
                              formData.findIndex(
                                (item) =>
                                  item.admission_no ===
                                  selectedStudent.studentId
                              ),
                              subjectIdx
                            );
                          }}
                          // onInput={(e) => {
                          //   const input = e.target as HTMLInputElement;
                          //   if (Number(input.value) > 20)alert("Maximum 20 marks allowed.");
                          //   if (Number(input.value) < 0) input.value = "0";
                          // }}
                        />
                      </td>
                      <td>
                        <input
                          style={inputStyle}
                          min={0}
                          max={70}
                          type="number"
                          placeholder="Enter Exam marks"
                          value={subjectData?.examScore ?? ""}
                          onChange={(e) => {
                            const inputValue = (e.target as HTMLInputElement)
                              .value;
                            const value = Math.min(
                              70,
                              Math.max(0, Number(inputValue) || 0)
                            ).toString(); // Convert to string
                            handleInputChange(
                              "examScore",
                              value,
                              formData.findIndex(
                                (item) =>
                                  item.admission_no ===
                                  selectedStudent.studentId
                              ),
                              subjectIdx
                            );
                          }}
                        />
                      </td>

                      <td className="text-center">{totalScore}</td>
                      <td className="text-center">
                        {totalScore !== "-"
                          ? getGrades(Number(totalScore), grade_setup)
                          : "-"}
                      </td>
                      <td className="text-center">
                        {totalScore !== "-"
                          ? getRemark(Number(totalScore), grade_setup)
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-footer text-end">
          <button
            type="button"
            className="btn btn-primary d-flex align-items-right mt-3"
            style={{}}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </Modal>
    </>
  );
};

export default GenereteClassReports;
